module.exports = __webpack_public_path__ + "static/img/10.adbca8d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/eng/10.png
// module id = y6Ru
// module chunks = 0